import { render, staticRenderFns } from "./BulkCandidateImport.vue?vue&type=template&id=4758638b"
import script from "./BulkCandidateImport.vue?vue&type=script&lang=js"
export * from "./BulkCandidateImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports